import { PLATFORM_CLASS } from './config';

/** iOS → appstore.png, Android/web → playstore.png (public/) */
export function getBrandLogoSrc() {
  const base = process.env.PUBLIC_URL || '';
  const file = PLATFORM_CLASS === 'platform-ios' ? 'appstore.png' : 'playstore.png';
  return `${base}/${file}`;
}
